import { create } from 'zustand';

export interface User {
  id: string;
  cognitoSub: string;
  nombre: string;
  email: string;
  role: 'gerente' | 'operaciones' | 'administrativo' | 'residente' | 'compras' | 'contabilidad';
  cargo: string | null;
  isActive: boolean;
}

export const DEV_USERS = {
  gerente: 'seed-gerente-001',
  operaciones: 'seed-operaciones-001',
  administrativo: 'seed-administrativo-001',
  residente: 'seed-residente-001',
  compras: 'seed-compras-001',
} as const;

export type DevRole = keyof typeof DEV_USERS;

export const isDevMode = import.meta.env.VITE_AUTH_MODE === 'dev';

// Persist dev auth state in localStorage so it survives page reloads
function getPersistedDevRole(): DevRole {
  if (!isDevMode) return 'administrativo';
  const stored = localStorage.getItem('octopaint_dev_role');
  if (stored && stored in DEV_USERS) return stored as DevRole;
  return 'administrativo';
}

function getPersistedDevLoggedIn(): boolean {
  if (!isDevMode) return false;
  return localStorage.getItem('octopaint_dev_logged_in') === 'true';
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  devRole: DevRole;
  devLoggedIn: boolean;
  setUser: (user: User) => void;
  clearUser: () => void;
  setLoading: (loading: boolean) => void;
  setDevRole: (role: DevRole) => void;
  setDevLoggedIn: (v: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  devRole: getPersistedDevRole(),
  devLoggedIn: getPersistedDevLoggedIn(),
  setUser: (user) => set({ user, isAuthenticated: true, isLoading: false }),
  clearUser: () => {
    if (isDevMode) {
      localStorage.removeItem('octopaint_dev_logged_in');
    }
    set({ user: null, isAuthenticated: false, isLoading: false, devLoggedIn: false });
  },
  setLoading: (isLoading) => set({ isLoading }),
  setDevRole: (devRole) => {
    if (isDevMode) localStorage.setItem('octopaint_dev_role', devRole);
    set({ devRole });
  },
  setDevLoggedIn: (v) => {
    if (isDevMode) localStorage.setItem('octopaint_dev_logged_in', String(v));
    set({ devLoggedIn: v });
  },
}));
